module.exports = __webpack_public_path__ + "static/media/redecorating_map.2bc007a7.svg";